module.exports = __webpack_public_path__ + "media/images/shared/app-view-7641396c583261d78fe145370981ab98257ce0f80070246afc995837d7f3cd6a.png";